<template>
  <div class="navbar">
    <div class="navbar-left">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb class="breadcrumb-container"></breadcrumb>
    </div>
    <div class="navbar-right">
      <span class="env-badge">运营后台</span>
      <span class="nav-date">{{ todayText }}</span>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              运营工作台
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span class="logout-action" @click="logout">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ]),
    todayText() {
      const d = new Date()
      const y = d.getFullYear()
      const m = `${d.getMonth() + 1}`.padStart(2, '0')
      const day = `${d.getDate()}`.padStart(2, '0')
      return `${y}-${m}-${day}`
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px 0 14px;
  border-bottom: 1px solid var(--admin-border);
  border-radius: 0px !important;
  background: var(--admin-surface);
  box-shadow: 0 10px 28px rgba(31, 42, 55, .04);
  .navbar-left {
    display: flex;
    min-width: 0;
    align-items: center;
  }
  .hamburger-container {
    display: flex;
    height: 40px;
    align-items: center;
    padding: 0 12px;
    border-radius: 8px;
    color: var(--admin-text-regular);
    &:hover {
      background: var(--admin-page-bg);
    }
  }
  .breadcrumb-container {
    margin-left: 6px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: var(--admin-danger);
  }
  .navbar-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .env-badge {
    display: inline-flex;
    height: 26px;
    align-items: center;
    padding: 0 10px;
    border: 1px solid var(--admin-primary-border);
    border-radius: 999px;
    color: var(--admin-primary);
    font-size: 12px;
    font-weight: 600;
    background: var(--admin-primary-soft);
  }
  .nav-date {
    color: var(--admin-text-muted);
    font-size: 13px;
  }
  .avatar-container {
    height: 40px;
    display: inline-block;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      display: flex;
      height: 40px;
      align-items: center;
      gap: 8px;
      .user-avatar {
        width: 34px;
        height: 34px;
        border-radius: 8px;
      }
      .el-icon-caret-bottom {
        font-size: 12px;
        color: var(--admin-text-muted);
      }
    }
  }
  .logout-action {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue